import { processNodeAndPermissions } from "../../../helper/com-helper";
import { DPAI } from "./DPAI";
import { PAI } from "./PAI";
import { DASHBOARD, SNOP } from "./SNOP";
import { SNP } from "./SNP";

const IBP_OBJECT = {
  name: "Integrated Business Planning",
  route: "/snop/dashboard",
  permissions: [],
  child: {
    "S&OP": SNOP,
    "Product Planning": PAI,
    "Demand Planning": DPAI,
    "Supply Planning": SNP,
    Dashboard: DASHBOARD,
  },
};

processNodeAndPermissions(IBP_OBJECT);
export const IBP = IBP_OBJECT;
